import React from "react";

/**
 * Period-over-period delta badge.
 *
 * Extracted from CountWidget and RateWidget, which each carried a
 * byte-identical copy, and now shared with the copilot's stat tiles so there
 * is one implementation instead of three.
 *
 * DIRECTION vs SENTIMENT are separate on purpose. Direction picks the arrow;
 * sentiment picks the colour. A rising bounce rate is up AND bad, so a badge
 * that colours purely by direction mislabels every inverse metric. Sentiment
 * defaults to direction, which is exactly the previous dashboard behaviour —
 * existing callers are unaffected.
 */
const ARROWS = { up: "↑", down: "↓" };

const toneFor = (direction, sentiment) => {
  if (sentiment === "positive") return "Up";
  if (sentiment === "negative") return "Down";
  if (sentiment === "neutral") return "Neutral";
  return direction === "up" ? "Up" : direction === "down" ? "Down" : "Neutral";
};

const TrendBadge = ({ trend, text, className = "" }) => {
  if (!trend) return null;
  const { percent, direction, sentiment } = trend;

  const tone = toneFor(direction, sentiment);
  const arrow = ARROWS[direction] || "—";
  const sign = direction === "up" ? "+" : direction === "down" ? "-" : "";
  // `text` overrides the default phrasing (the copilot says "vs last month",
  // "23 ms faster", …); without it, the dashboard's original wording stands.
  // `trend.text` lets a caller override the wording WITHOUT the badge being
  // rendered directly — CountWidget/RateWidget just forward the trend object.
  const label =
    text != null
      ? text
      : trend.text != null
        ? trend.text
      : percent != null
        ? `${sign}${Math.abs(percent).toFixed(0)}% vs prev. period`
        : "";

  return (
    <div className={`widgetCardTrendBadge widgetCardTrendBadge${tone} ${className}`.trim()}>
      <span className="trendArrow">{arrow}</span>
      <span>{label}</span>
    </div>
  );
};

export default TrendBadge;
